import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { Validator } from '@adornis/validation/validator.js';
import { sgNonOptional } from '@martinus/validation/sgNonOptional.js';
import { Kostenstelle } from '../../../../groups/entities/Kostenstelle.js';

/**
 * @entity KostenstelleProzentsatz
 * Describes the percentage and the kostenstelle on a Vertrag. A Vertrag can have multiple Taetigkeiten and therefore multiple Kostenstellen. To which percentile does each
 */
@Entity()
export class KostenstelleProzentsatz extends AdornisEntity {
  static override _class = 'KostenstelleProzentsatz';

  static override resolveID(entity: any): string {
    return entity._id ?? (entity._id = A.getGloballyUniqueID());
  }

  @Field(type => ID, { default: v => v ?? A.getGloballyUniqueID() })
  _id!: string;

  @validate(sgNonOptional())
  @Field(type => ID)
  kostenstelleID: Maybe<string>;

  @DataLoadedField(type => Kostenstelle, ({ kostenstelleID }) => kostenstelleID)
  kostenstelle: Maybe<Kostenstelle>;

  @Field(type => Float, { default: v => v ?? 100.0 })
  prozentsatz: Maybe<number>;
}

if (A.isClient) {
  KostenstelleProzentsatz.prototype.validator = new Validator({
    kostenstelleID: nonOptional(),
    prozentsatz: nonOptional(),
  });
}
